<div class="dialog-content-wrapper" style="margin: -24px;">
    <mat-toolbar matDialogTitle class="mat-indigo-800-bg m-0 customBlue">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title"> {{ dialogHeader }}</span>
            <button mat-button class="mat-icon-button" (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar style="padding-bottom:0px !important;">
        <form class="user-actions" novalidate>
            <section class="example-section" *ngIf="actionType == 21">
                <mat-checkbox *ngFor="let record of umList; let i = index;" [(ngModel)]="record.Status" [ngModelOptions]="{standalone: true}" class="example-margin" align="end">
                    {{ record.Name }}
                </mat-checkbox>
            </section>
            <section class="example-section" *ngIf="actionType != 21">
                <table style="width: 100%;">
                    <tr style="background: aliceblue;">
                        <td style="text-align: left !important;width: 60% !important;">
                            <label class="mat-checkbox-layout">
                                <span class="mat-checkbox-label"><span style="display:none">&nbsp;</span>
                                    {{translations.lblDistShipperName}}</span>
                            </label></td>
                        <td style="text-align: center !important; width: 20% !important;">
                            <label class="mat-checkbox-layout">
                                <span class="mat-checkbox-label" style="text-align: center !important;"><span style="display:none">&nbsp;</span>
                                    {{translations.lblMap}}</span>
                            </label></td>
                        <td style="text-align: center !important; width: 20% !important;">
                            <label class="mat-checkbox-layout">
                                <span class="mat-checkbox-label" style="text-align: center !important;"><span style="display:none">&nbsp;</span>
                                    {{translations.lblSendEmail}}</span>
                            </label></td>
                    </tr>
                    <tr *ngFor="let record of umList; let i = index;" style="background: aliceblue;">
                        <label class="mat-checkbox-layout" for="mat-checkbox-2-input">
                            <span class="mat-checkbox-label"><span style="display:none">&nbsp;</span>
                                {{ record.Name }}</span></label>
                        <td style="text-align: center !important; width: 20% !important;">
                            <mat-checkbox [(ngModel)]="record.Status" [ngModelOptions]="{standalone: true}" class="example-margin user-mapping" align="end">
                            </mat-checkbox>
                        </td>
                        <td style="text-align: center !important;width: 20% !important;">
                            <mat-checkbox [(ngModel)]="record.SendEmail" [ngModelOptions]="{standalone: true}" class="example-margin user-mapping" align="end">
                            </mat-checkbox>
                        </td>
                    </tr>

                </table>
            </section>
        </form>
    </div>
    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="left">
        <button mat-raised-button color="accent" [disabled]="umList != undefined && umList.length == 0" aria-label="SAVE" (click)="save();" fxFlex="47">
            {{translations.btnSave}}
        </button>
        <button mat-raised-button color="warn" aria-label="CLOSE" mat-dialog-close fxFlex="47">
            {{translations.btnCancel}}
        </button>
    </div>
</div>



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/user/user-actions-form/user-actions-form.component.html